import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";
//empty commit
export const getCJWDiBatchCostFiles = async (batchId) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiBatchCostFiles}/${encodeURIComponent(batchId)}`;
  const response = await getAPI(apiUrl, tokenInfo);

  if (response.ok) {
    const payload = await response.json().catch(() => []);
    return Array.isArray(payload) ? payload : [];
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to load generated cost files.", { contactSupport: false });
  throw new Error(errorData?.message || "Failed to load generated cost files.");
};

export default getCJWDiBatchCostFiles;
